import { defineStore } from 'pinia';
import { ref } from 'vue';
import serverFetch from '@globals/ServerFetch';
import RfpsList from '@customer/rfp/RfpsList';

import { RfpItem } from '@customer/types/rfp/RfpItem';
import type { RfpListType } from '@customer/types/rfp/RfpList';

export const useCustomerRfpListStore = defineStore('customerRfpList', () => {
	const state = {
		rfpsList: ref(new RfpsList('Rfps')),
		contactsList: ref(new RfpsList('Contacts')),
		displayAutomaticRecommendationsContactBanner: ref(false),
		displayAutomaticRecommendationsRfpListBanner: ref(false),
		displayExpandLimitBanner: ref(false),
		isFromListBox: ref(false),
		fromListType: ref(''),
		selectedRfpId: ref(-1),
		selectedRfp: ref<RfpItem | null>(null),
		selectedListType: ref<RfpListType | null>('Rfps'),
		selectedFilterQuery: ref({}),
		photoPreview: ref(''),
		photoPreviewFilename: ref(''),
		isAutoUncover: ref(false),
		toggleChat: ref(false),
		isPublicView: ref(false),
	};

	const actions = {
		getPublicRfpListUrl() {
			return actions.getList('Rfps').publicRfpListUrl || '/zapytania';
		},
		shouldDisplayExpandLimitBanner() {
			const banner = actions.getList('Rfps').expandLimitBanner;
			state.displayExpandLimitBanner.value = !!banner;
			return banner;
		},
		async shouldDisplayAutomaticRecommendationsBanner(isContacts: boolean) {
			// if (state.displayAutomaticRecommendationsContactBanner.value && isContacts) { return; }
			// if (state.displayAutomaticRecommendationsRfpListBanner.value && !isContacts) { return; }

			const url = `/customer/should-display-ap-${isContacts ? 'contacts' : 'rfp-list'}-stimulation-box.do`;
			const { shouldDisplayApStimulationBox: display } = await serverFetch(url, {}, 'GET', false, false);
			if (isContacts) {
				state.displayAutomaticRecommendationsContactBanner.value = display;
			} else {
				state.displayAutomaticRecommendationsRfpListBanner.value = display;
			}
		},
		getList(listType: RfpListType) {
			const listName = listType.toLowerCase();
			return state[`${listName}List` as 'rfpsList' | 'contactsList'].value;
		},
		updateFlags(flags: string[]) {
			if (flags && flags.indexOf('show_best_rfps') > -1) {
				actions.getList('Rfps').ShowBestRfps = true;
			}
		},
		getRfpById(id: number | string): RfpItem | null {
			const rfps = this.rfpsList?.Rfps || [];
			return rfps.find((rfp) => Number(rfp.Id) === Number(id)) || null;
		},
		removeRfp(rfp: RfpItem, index = -1) {
			const list = actions.getList(state.selectedListType.value);
			if (index === -1) {
				const idx = list.Rfps.findIndex((item: RfpItem) => item.Id === rfp.Id);
				if (idx !== -1) {
					list.RemoveRfp(rfp, idx);
				}
			} else {
				list.RemoveRfp(rfp, index);
			}
		},
		async fetchRfpById(id: number | string, listType: RfpListType = 'Rfps'): Promise<RfpItem | null> {
			const rfp = this.getRfpById(id);
			if (rfp) {
				state.selectedRfp.value = rfp;
				state.selectedRfpId.value = Number(id);
				return rfp;
			}

			const list = this.getList(listType);
			if (!list || !list.GetRfp) {
				state.selectedRfp.value = null;
				state.selectedRfpId.value = -1;
				return null;
			}
			try {
				const fetchedRfp = await list.GetRfp(Number(id));
				if (fetchedRfp) {
					state.selectedRfp.value = fetchedRfp;
					state.selectedRfpId.value = Number(id);
					return fetchedRfp;
				}
			} catch (e) {
				console.error('Błąd podczas fetchowania RFP:', e, 'dla id:', id);
			}
			state.selectedRfp.value = null;
			state.selectedRfpId.value = -1;
			return null;
		},
	};

	const getters = {
	};

	return { ...state, ...actions, ...getters };
});
